import { Col, Row } from 'antd';
import './HomePage.scss';
import { useTranslation } from 'react-i18next';
import HeroSection from './components/HeroSection';
import MarketPulse from './components/MarketPulse';
import RegionalPrice from './components/RegionalPrice';
import NLPSection from './components/NLPSection';
import SelectRole from './components/SelectRole';
import News from './components/News';
import NewsLettersList from './components/newsLetter/NewsLettersList';
import { useUserContext } from '../../contexts/UserContext';
import { useRef } from 'react';

const HomePageView = () => {
  const { t } = useTranslation(['home']);
  const { IsAuthenticated } = useUserContext();

  const regionalPriceRef = useRef<HTMLDivElement>(null);
  const latestReportsRef = useRef<HTMLDivElement>(null);

  const scrollToRegionalPriceRef = () => {
    if (regionalPriceRef.current) {
      regionalPriceRef.current.scrollIntoView({
        behavior: 'smooth', // makes it smooth
        block: 'start', // align to top
      });
    }
  };

  const scrollToLatestReportsRef = () => {
    if (latestReportsRef.current) {
      latestReportsRef.current.scrollIntoView({
        behavior: 'smooth', // makes it smooth
        block: 'start', // align to top
      });
    }
  };

  return (
    <>
      <Row className="home-main-container p-6">
        <Col span={24}>
          <HeroSection
            t={t}
            scrollToRegionalPriceRef={scrollToRegionalPriceRef}
            scrollToLatestReportsRef={scrollToLatestReportsRef}
          />
          <MarketPulse t={t} />
          <RegionalPrice t={t} ref={regionalPriceRef} />
          {/* <NLPSection /> */}
          {/* {!IsAuthenticated() && <SelectRole t={t} />} */}
          {/* <SelectRole t={t} /> */}

          <News t={t} />

          {/* --- Not implemented yet --- */}
          <NewsLettersList t={t} ref={latestReportsRef} />
        </Col>
      </Row>
    </>
  );
};

const HomePage = () => {
  return <HomePageView />;
};

export default HomePage;
